import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/images/contact.png'


const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 campaign-contact-box" }
const _hoisted_2 = { class: "card-body letter-spacing position-relative" }
const _hoisted_3 = { class: "fw-medium text-white mb-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("strong", { class: "fw-black" }, "Campaign", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-right-arrow-1" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "contact-image"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, [
        _createTextVNode(" Enhance Your "),
        _hoisted_4,
        _createTextVNode(" For Better Outreach "),
        _createVNode(_component_router_link, {
          to: "/account-settings",
          class: "text-white text-decoration-none lh-1 position-relative ms-5 top-3"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _hoisted_6
    ])
  ]))
}